import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { Analytics } from "@vercel/analytics/react";
import ChatWidget from "@/components/ChatWidget";
import Index from "./pages/Index";
import AboutPage from "./pages/AboutPage";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import SetupPassword from "./pages/SetupPassword";
import ChatAssistant from "./pages/products/ChatAssistant";
import VoiceAssistant from "./pages/products/VoiceAssistant";
import EmailAssistant from "./pages/products/EmailAssistant";
import AIAutomation from "./pages/products/AIAutomation";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <Analytics />
      <BrowserRouter>
        <LanguageProvider>
          <ChatWidget />
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/is" replace />} />
              <Route path="/is" element={<Index />} />
              <Route path="/en" element={<Index />} />
              <Route path="/is/about" element={<AboutPage />} />
              <Route path="/en/about" element={<AboutPage />} />
              <Route path="/is/login" element={<Login />} />
              <Route path="/en/login" element={<Login />} />
              <Route path="/setup-password" element={<SetupPassword />} />
              <Route path="/is/products/chat" element={<ChatAssistant />} />
              <Route path="/en/products/chat" element={<ChatAssistant />} />
              <Route path="/is/products/voice" element={<VoiceAssistant />} />
              <Route path="/en/products/voice" element={<VoiceAssistant />} />
              <Route path="/is/products/email" element={<EmailAssistant />} />
              <Route path="/en/products/email" element={<EmailAssistant />} />
              <Route path="/is/products/automation" element={<AIAutomation />} />
              <Route path="/en/products/automation" element={<AIAutomation />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
